import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import axios from "axios";
import Add from "../../../../modal/Settings/Purchase_Management/Raw_Material_Sub_Category/AddRawMaterialSubCat";
import Edit from "../../../../modal/Settings/Purchase_Management/Raw_Material_Sub_Category/EditRawMaterialSubCat";

const RawMaterialSubCategory = () => {
  const tableRef = useRef(null);
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [selectedSub, setSelectedSub] = useState(null);

  // Pagination and search states
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  const baseURL = process.env.REACT_APP_API_BASE_URL;

  // Fetch all subcategories
  const fetchSubCategories = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${baseURL}/rawmaterial-sub`);
      if (response.data.success) {
        setSubCategories(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubCategories();
  }, []);

  // Filter + Pagination Logic
  const filteredData = subCategories.filter(
    (sub) =>
      sub.subcategory_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      sub.rawmaterial_category_details?.rawmaterialcategory_name
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase())
  );

  const totalEntries = filteredData.length;
  const totalPages = Math.ceil(totalEntries / perPage);
  const startIndex = (page - 1) * perPage;
  const paginatedData = filteredData.slice(startIndex, startIndex + perPage);

  // Open Add/Edit Modal
  const handleModalToggle = (type, sub = null) => {
    setModalType(type);
    setSelectedSub(sub);
    setOpen(true);
  };

  // Delete Modal
  const DeleteModal = (sub) => {
    swal
      .fire({
        html: `
          <div class="alert alert-danger px-2 py-2" role="alert">
            <strong>OOPS! </strong> You're about to delete a Raw Material Sub Category
          </div>
          <p class="text-center"><b>${sub.subcategory_name}</b></p>
        `,
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        customClass: {
          title: "fs-6",
          cancelButton: "btn btn-sm btn-secondary",
          confirmButton: "btn btn-sm btn-danger",
          htmlContainer: "text-left",
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            await axios.delete(`${baseURL}/rawmaterial-sub/delete/${sub.sno}`);
            swal.fire({
              title: "Deleted!",
              text: `${sub.subcategory_name} has been deleted.`,
              icon: "success",
              confirmButtonText: "OK",
              customClass: {
                title: "fs-6",
                confirmButton: "btn btn-sm btn-primary",
              },
            });
            fetchSubCategories(); // Refresh table
          } catch (err) {
            console.error(err);
            swal.fire("Error", "Failed to delete the subcategory.", "error");
          }
        } else {
          swal.fire({
            title: "Cancelled",
            text: `Deletion cancelled`,
            icon: "warning",
            confirmButtonText: "OK",
            customClass: {
              title: "fs-6",
              confirmButton: "btn btn-sm btn-primary",
            },
          });
        }
      });
  };

  
      const handleStatusToggle = async (id, currentStatus) => {
          const newStatus = currentStatus === 0 ? 1 : 0;
          axios.post(`${baseURL}/rawmaterial-sub/status/${id}`, {status: newStatus})
              .then(response => {
                  // window.location.reload();
                  fetchSubCategories();
                //   toast.success("Status Updated Successfully!");
              })
              .catch(error => {
                  console.log(error);
                //   toast.error("Status Updation Failed");
              });
      };
  

  return (
    <>
      <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
        <div className="mb-2">
          <div className="mb-0 px-0">
            <h4 style={{ color: "#ea1d25" }}>Raw Material Sub Category</h4>
          </div>
          <ol className="breadcrumb fs-7">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li className="breadcrumb-item">
              <i className="fa-solid fa-angles-right fs-8"></i>
            </li>
            <li className="breadcrumb-item">
              <Link to="/settings">Settings</Link>
            </li>
            <li className="breadcrumb-item">
              <i className="fa-solid fa-angles-right fs-8"></i>
            </li>
            <li className="breadcrumb-item active">Purchase Management</li>
          </ol>
        </div>
        <Button
          className="btn btn-primary float-end btn-sm mb-2"
          onClick={() => handleModalToggle("Add")}
        >
          <span className="me-2">
            <i className="fa-solid fa-plus fs-8"></i>
          </span>
          Add Raw Material Sub Category
        </Button>

        {open && modalType === "Add" && (
          <Add
            show={open}
            onClose={() => setOpen(false)}
            onUpdated={fetchSubCategories}
          />
        )}
        {open && modalType === "Edit" && selectedSub && (
          <Edit
            show={open}
            subCategory={selectedSub}
            onClose={() => setOpen(false)}
            onUpdated={fetchSubCategories}
          />
        )}
      </div>

      {/* TABLE SECTION */}
      <div className="table-container">
        <div className="d-flex justify-content-between align-items-center mb-3">
          {/* Left: Show entries */}
          <div>
            <label className="me-2">Show</label>
            <select
              className="form-select d-inline w-auto"
              style={{ fontSize: "0.85rem", height: "30px" }}
              value={perPage}
              onChange={(e) => {
                setPerPage(Number(e.target.value));
                setPage(1);
              }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>

          {/* Right: Search */}
          <div>
            <input
              type="text"
              style={{ fontSize: "0.85rem", height: "40px" }}
              placeholder="Search..."
              className="form-control"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setPage(1);
              }}
            />
          </div>
        </div>

        <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
          <thead>
            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
              <th className="min-w-50px">S.No</th>
              <th className="min-w-200px">Raw Material Sub Category</th>
              <th className="min-w-200px">Raw Material Category</th>
              <th className="min-w-200px">Description</th>
              <th className="min-w-100px">Status</th>
              <th className="min-w-100px">Actions</th>
            </tr>
          </thead>
          <tbody className="text-gray-600 fw-semibold fs-7">
            {loading ? (
              <tr>
                <td colSpan="6" className="text-center">
                  Loading...
                </td>
              </tr>
            ) : paginatedData.length > 0 ? (
              paginatedData.map((sub, index) => (
                <tr key={sub.sno}>
                  <td className="text-black text-start">
                    {(page - 1) * perPage + index + 1}
                  </td>
                  <td className="text-black">{sub.subcategory_name}</td>
                  <td className="text-black">
                    {sub.rawmaterial_category_details?.rawmaterialcategory_name ||
                      "N/A"}
                  </td>
                  <td className="text-black">{sub.description || "-"}</td>
                    <td>
                        <div className="form-check form-switch d-flex align-items-center mb-3">
                            <input className="form-check-input me-2" type="checkbox" role="switch" defaultChecked={sub.status === 0} onChange={() => handleStatusToggle(sub.sno, sub.status)} />
                        </div>
                    </td>
                  <td className="text-center">
                    <OverlayTrigger
                      trigger="hover"
                      placement="bottom"
                      overlay={<Tooltip>Edit</Tooltip>}
                    >
                      <Button
                        variant="primary tp-btn-light px-2 py-1 me-1"
                        onClick={() => handleModalToggle("Edit", sub)}
                      >
                        <i className="fa-solid fa-pen-to-square fs-6 mt-1"></i>
                      </Button>
                    </OverlayTrigger>

                    <OverlayTrigger
                      trigger="hover"
                      placement="bottom"
                      overlay={<Tooltip>Delete</Tooltip>}
                    >
                      <Button
                        variant="primary tp-btn-light px-2 py-1 me-1"
                        onClick={() => DeleteModal(sub)}
                      >
                        <i className="fa-solid fa-trash-can fs-6 mt-1"></i>
                      </Button>
                    </OverlayTrigger>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No subcategories found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination Footer */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <div>
            {paginatedData.length > 0 ? (
              <span className="text-muted">
                Showing {startIndex + 1} to{" "}
                {Math.min(startIndex + paginatedData.length, totalEntries)} of{" "}
                {totalEntries} entries
              </span>
            ) : (
              <span className="text-muted">Showing 0 to 0 of 0 entries</span>
            )}
          </div>

          <nav>
            <ul className="pagination mb-0" style={{ fontSize: "0.75rem" }}>
              <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button
                  className="page-link"
                  style={{ padding: "0.25rem 0.5rem" }}
                  onClick={() => setPage(page - 1)}
                >
                  Previous
                </button>
              </li>
              {[...Array(totalPages)].map((_, i) => (
                <li
                  key={i}
                  className={`page-item ${page === i + 1 ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    style={{ padding: "0.25rem 0.5rem" }}
                    onClick={() => setPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              ))}
              <li
                className={`page-item ${page === totalPages ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  style={{ padding: "0.25rem 0.5rem" }}
                  onClick={() => setPage(page + 1)}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
};

export default RawMaterialSubCategory;
